import React from "react";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../../../Resident/fetch";
import { prepareAffiliateMember, prepareAffiliateMemberDetail, prepareAffiliateMemberAddress } from "../helpers/pepare_for_update";

function AutoSave() {
  const fetch = useFetch();
  const dispatch = useDispatch();

  const props = useSelector((state) => {
    return {
      affiliateMember: state.affiliateMember,
      affiliateMemberDetail: state.affiliateMemberDetail,
      affiliateMemberAddress: state.affiliateMemberAddress,
      organizationName: state.organization.name,
    };
  });

  const updateSaving = (saving) => dispatch({ type: "UPDATE_SAVING", payload: { saving }});
  const updateUpdatedAt = (updated_at) => dispatch({ type: "UPDATE_MEMBER_UPDATED_AT", payload: { member_updated_at: updated_at }});

  const autoSaveAffiliateMember = () => {
    const data = prepareAffiliateMember(props.affiliateMember);
    const url = `/organizations/${props.organizationName}/affiliate_members/${props.affiliateMember.id}.json`;
    autoSaveObject(data, url);
  };

  const autoSaveAffiliateMemberDetail = () => {
    const data = prepareAffiliateMemberDetail(props.affiliateMemberDetail);
    const url = `/organizations/${props.organizationName}/affiliate_members/${props.affiliateMember.id}/detail.json`;
    autoSaveObject(data, url);
  };

  const autoSaveAffiliateMemberAddress = () => {
    const data = prepareAffiliateMemberAddress(props.affiliateMemberAddress);
    const url = `/organizations/${props.organizationName}/affiliate_members/${props.affiliateMember.id}/detail/update_address.json`;
    autoSaveObject(data, url);
  };

  const autoSaveObject = (data, url) => {
    updateSaving(true);
    fetch(url, {
      method: "PATCH",
      data: data,
    }).then((data) => {
      updateSaving(false);
      if (data.affiliate_member) {
        updateUpdatedAt(data.affiliate_member.updated_at);
      }
      if (data.affiliate_member_detail) {
        updateUpdatedAt(data.affiliate_member_detail.updated_at);
      }
      if (data.affiliate_member_address) {
        updateUpdatedAt(data.affiliate_member_address.updated_at);
      }
    }).fail(() => {
      updateSaving(false);
    });
  };

  return {
    autoSaveAffiliateMember,
    autoSaveAffiliateMemberDetail,
    autoSaveAffiliateMemberAddress,
  };
}

export default AutoSave;
